import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Coupon } from '../models/membership/Coupon'
import { COUPONS_URL } from '../utils/urls'

const fetchCoupons = (params: TableParams) =>
  SBAPI.FetchPaginated<Coupon[]>(COUPONS_URL, params)

const fetchCouponById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Coupon>(`${COUPONS_URL}/${id}`, params)

const createCoupon = (coupon: Coupon) => SBAPI.Post(COUPONS_URL, coupon)

const updateCoupon = (coupon: Coupon) =>
  SBAPI.Put(`${COUPONS_URL}/${coupon.id}`, coupon)

const deleteCoupon = (coupon: Coupon) =>
  SBAPI.Delete(`${COUPONS_URL}/${coupon.id}`)

export {
  createCoupon,
  deleteCoupon,
  fetchCouponById,
  fetchCoupons,
  updateCoupon,
}
